const API =
    process.env.REACT_APP_LINK_API;
console.log("API:", API);
function headers(user) {
    return {
        "Content-Type": "application/json",
        "x-user-uid": user.uid,
        "x-user-email": user.email || "",
        "x-user-name": user.displayName || ""
    };
}

export async function getDashboard(user) {

    const response =
        await fetch(
            `${API}/api/dashboard`,
            {
                headers: headers(user)
            }
        );

    return response.json();
}

export async function getLinks(user) {

    const response =
        await fetch(
            `${API}/api/links`,
            {
                headers: headers(user)
            }
        );

    return response.json();
}

export async function createLink(
    user,
    payload
) {

    const response =
        await fetch(
            `${API}/api/links`,
            {
                method: "POST",
                headers: headers(user),
                body: JSON.stringify(payload)
            }
        );

    return response.json();
}

export async function updateLink(
    user,
    code,
    payload
) {

    const response =
        await fetch(
            `${API}/api/links/${code}`,
            {
                method: "PUT",
                headers: headers(user),
                body: JSON.stringify(payload)
            }
        );

    return response.json();
}

export async function deleteLink(
    user,
    code
) {

    const response =
        await fetch(
            `${API}/api/links/${code}`,
            {
                method: "DELETE",
                headers: headers(user)
            }
        );

    return response.json();
}

export async function getStats(
    user,
    code
) {

    const response =
        await fetch(
            `${API}/api/links/${code}/stats`,
            {
                headers: headers(user)
            }
        );

    return response.json();
}

export async function getRecentClicks(
    currentUser
) {

    const response =
        await fetch(
            `${API}/api/recent-clicks`,
            {
                headers:
                    headers(
                        currentUser
                    )
            }
        );

    return response.json();

}